module.exports = {
    WAIT: 'WAIT',
}
